// src/components/incentives-collection-carousel/incentives-collection-carousel.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment CollectionClickstreamAnalyticsFragment on CollectionClickstreamAnalytics {\n    event {\n      eventCategory\n      eventName\n      eventType\n      eventVersion\n    }\n    payload {\n      collectionId\n      collectionType\n      componentPosition\n      destinationGeoId\n      productId\n      trackingId\n      componentName\n      componentId\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    __typename\n    accessibility\n    primary\n    disabled\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesActionLinkFragment on IncentivesActionLink {\n    resource {\n      value\n    }\n    button {\n      ...EGDSButtonFragment\n    }\n    accessibility\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    clickAnalytics {\n      linkName\n      referrerId\n    }\n    presentedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n    selectedAnalytics {\n      ...CollectionClickstreamAnalyticsFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesImageAttributionDialogFragment on IncentivesImageAttributionDialog {\n    text\n    closeText\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesImageAttributionFragment on IncentivesImageAttribution {\n    dialog {\n      ...IncentivesImageAttributionDialogFragment\n    }\n    dialogTriggerAccessibility\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesCollectionCarouselImageFragment on IncentivesImage {\n    image {\n      description\n      url\n    }\n    attribution {\n      ...IncentivesImageAttributionFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesContentItemFragment on IncentivesContentItem {\n    actionLink {\n      ...IncentivesActionLinkFragment\n    }\n    incentivesImage {\n      ...IncentivesCollectionCarouselImageFragment\n    }\n    title\n    subtitle\n    recommendationId\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment IncentivesCollectionCarouselHeaderFragment on IncentivesCollectionHeader {\n    title\n    subtitle\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  query CollectionCarouselQuery($context: ContextInput!, $collectionId: String!, $pageContext: PageContextInput) {\n    incentivesCollection(context: $context, collectionId: $collectionId, pageContext: $pageContext) {\n      collectionHeader {\n        ...IncentivesCollectionCarouselHeaderFragment\n      }\n      collectionItems {\n        ...IncentivesContentItemFragment\n      }\n      egRecommendationResponseId\n      impressionAnalytics {\n        event\n        referrerId\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import React9 from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { EGDSCarousel as EGDSCarousel2 } from "@egds/react-core/carousel";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
// ../internal/src/utility/analytics/get-recommendation.ts
var getRecommendation = function(collectionItem) {
    var _collectionItem_price;
    var _collectionItem_badges;
    return {
        recommendationId: collectionItem.recommendationId,
        rank: collectionItem.index,
        presentationDetails: _object_spread({
            name: collectionItem.title,
            imageUrl: collectionItem.imageUrl,
            badges: (_collectionItem_badges = collectionItem.badges) !== null && _collectionItem_badges !== void 0 ? _collectionItem_badges : ""
        }, ((_collectionItem_price = collectionItem.price) === null || _collectionItem_price === void 0 ? void 0 : _collectionItem_price.currency) && {
            price: {
                displayPrice: collectionItem.price.displayPrice,
                currency: collectionItem.price.currency
            }
        })
    };
};
// ../internal/src/utility/analytics/get-recommendation-event.ts
var getRecommendationEvent = function(eventInfo, eventName, eventType) {
    return {
        eventType: eventType !== null && eventType !== void 0 ? eventType : "recommendationInteraction",
        eventName: eventName,
        egRecommendationResponseId: eventInfo.egRecommendationResponseId,
        recommendationTitle: eventInfo.title,
        component: eventInfo.componentType,
        componentElement: "thumbnail"
    };
};
// ../internal/src/utility/analytics/get-recommendation-clicked-message.ts
var getRecommendationClickedMessage = function(collectionEventingDetails, eventType) {
    if (!collectionEventingDetails || !collectionEventingDetails.items[0]) {
        return void 0;
    }
    var recommendationEvent = _object_spread_props(_object_spread({}, getRecommendationEvent(collectionEventingDetails, "recommendationClicked", eventType)), {
        recommendations: [
            getRecommendation(collectionEventingDetails.items[0])
        ]
    });
    return [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ];
};
// ../internal/src/utility/analytics/get-recommendation-seen-message.ts
var getRecommendationSeenMessage = function(collectionEventingDetails) {
    var scroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", eventType = arguments.length > 2 ? arguments[2] : void 0;
    var _collectionEventingDetails_items;
    if (!collectionEventingDetails) {
        return void 0;
    }
    var recommendations = (_collectionEventingDetails_items = collectionEventingDetails.items) === null || _collectionEventingDetails_items === void 0 ? void 0 : _collectionEventingDetails_items.filter(function(n) {
        return n;
    }).map(function(resultItem) {
        return getRecommendation(resultItem);
    });
    var recommendationEvent = _object_spread_props(_object_spread({}, getRecommendationEvent(collectionEventingDetails, "recommendationSeen", eventType)), {
        scroll: scroll,
        recommendations: recommendations
    });
    return (recommendations === null || recommendations === void 0 ? void 0 : recommendations.length) ? [
        {
            schemaName: "allRecommendations",
            messageContent: recommendationEvent
        }
    ] : void 0;
};
// ../internal/src/utility/analytics/eg-clickstream-helper.ts
var buildClickstreamAnalyticsEvent = function(clickstreamAnalytics) {
    var _clickstreamAnalytics_event = clickstreamAnalytics.event, eventName = _clickstreamAnalytics_event.eventName, eventType = _clickstreamAnalytics_event.eventType, eventVersion = _clickstreamAnalytics_event.eventVersion, eventCategory = _clickstreamAnalytics_event.eventCategory;
    var _clickstreamAnalytics_payload = clickstreamAnalytics.payload, collectionId = _clickstreamAnalytics_payload.collectionId, collectionType = _clickstreamAnalytics_payload.collectionType, productId = _clickstreamAnalytics_payload.productId, destinationGeoId = _clickstreamAnalytics_payload.destinationGeoId, trackingId = _clickstreamAnalytics_payload.trackingId, componentPosition = _clickstreamAnalytics_payload.componentPosition, componentName = _clickstreamAnalytics_payload.componentName, componentId = _clickstreamAnalytics_payload.componentId;
    var productObject = productId ? {
        product_list: [
            {
                product_id: productId
            }
        ]
    } : null;
    var destinationObject = destinationGeoId ? {
        destination: {
            destination_geo_id: destinationGeoId
        }
    } : null;
    var additionalContextObject = componentPosition || componentName || componentId ? {
        additional_context: {
            user_interface: {
                component_position: componentPosition,
                component_id: componentId,
                component_name: componentName
            }
        }
    } : null;
    var baseObject = {
        event: {
            event_name: eventName,
            event_version: eventVersion,
            event_type: eventType,
            event_category: eventCategory
        },
        incentive: {
            collection_id: collectionId,
            collection_type: collectionType.toLowerCase(),
            incentive_tracking_id: trackingId
        }
    };
    return _object_spread({}, baseObject, productObject, destinationObject, additionalContextObject);
};
// src/components/incentives-collection-carousel/incentives-collection-carousel.tsx
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
// src/components/placeholder.tsx
import React from "react";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSFigure, EGDSFigureAspectRatioType } from "@egds/react-core/images";
import { EGDSBlockSkeleton, EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { useLocalization } from "@shared-ui/localization-context";
var Placeholder = function() {
    var formatText = useLocalization().formatText;
    var carouselProps = {
        carouselName: "IncentivesCollectionCarousel",
        itemsVisible: {
            sm: 2,
            md: 3,
            lg: 4,
            xl: 5
        },
        pageBy: 1,
        peek: true,
        wrapItems: false,
        buttonText: {
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev")
        }
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EGDSSpacing, {
        margin: {
            block: "three"
        }
    }, /* @__PURE__ */ React.createElement(EGDSLineSkeleton, {
        animation: true
    })), /* @__PURE__ */ React.createElement(EGDSCarousel, _object_spread({}, carouselProps), _to_consumable_array(Array(6)).map(function(_, index) {
        return /* @__PURE__ */ React.createElement("div", {
            key: "incentives-collection-placeholder-card-".concat(index)
        }, /* @__PURE__ */ React.createElement(EGDSFigure, {
            ratio: EGDSFigureAspectRatioType.R4_3
        }, /* @__PURE__ */ React.createElement(EGDSBlockSkeleton, {
            animation: true
        })));
    })));
};
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-content-item.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection, EGDSCardLink } from "@egds/react-core/cards";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
// ../internal/src/components/incentives-action-link/incentives-action-link.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/utility/analytics/fragments/collection-clickstream-analytics-fragment.ts
import { gql } from "@apollo/client";
var CollectionClickstreamAnalyticsFragment = gql(_templateObject());
// ../internal/src/components/egds-button/egds-button.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
var fragment = gql2(_templateObject1());
var Button = function(param) {
    var data = param.data, size = param.size, isFullWidth = param.isFullWidth, onClickHandler = param.onClickHandler, href = param.href, className = param.className, onClickCapture = param.onClickCapture, inverse = param.inverse;
    var __typename = data.__typename, primary = data.primary, accessibility = data.accessibility, disabled = data.disabled;
    if (!primary) {
        return null;
    }
    var ButtonComponent = EGDSPrimaryButton;
    if (__typename === "UISecondaryButton") {
        ButtonComponent = EGDSSecondaryButton;
    } else if (__typename === "UITertiaryButton") {
        ButtonComponent = EGDSTertiaryButton;
    }
    return /* @__PURE__ */ React2.createElement(ButtonComponent, {
        size: size,
        href: href,
        isFullWidth: isFullWidth,
        onClick: onClickHandler,
        disabled: disabled,
        className: className,
        onClickCapture: onClickCapture,
        inverse: inverse
    }, primary, /* @__PURE__ */ React2.createElement("span", {
        className: "is-visually-hidden"
    }, accessibility));
};
Button.fragment = fragment;
Button.displayName = "Button";
// ../internal/src/components/incentives-action-link/incentives-action-link.tsx
var __fragment = gql3(_templateObject2(), CollectionClickstreamAnalyticsFragment, Button.fragment);
var IncentivesActionLink = function(props) {
    var data = props.data, className = props.className, buttonSize = props.buttonSize, buttonIsFullWidth = props.buttonIsFullWidth, buttonClickHandler = props.buttonClickHandler, additionalUisPrimeMicroMessages = props.additionalUisPrimeMicroMessages, visuallyHidden = props.visuallyHidden, multiArmBanditTrack = props.multiArmBanditTrack, inverseButton = props.inverseButton;
    var accessibility = data.accessibility, resource = data.resource, clickAnalytics = data.clickAnalytics, button = data.button, selectedAnalytics = data.selectedAnalytics;
    var track = useEgClickstream();
    var clickTracker = useClickTracker();
    var onClickCapture = function() {
        if (selectedAnalytics) {
            track(buildClickstreamAnalyticsEvent(selectedAnalytics));
        }
        multiArmBanditTrack === null || multiArmBanditTrack === void 0 ? void 0 : multiArmBanditTrack();
        if (clickAnalytics.referrerId) {
            clickTracker(clickAnalytics.referrerId, clickAnalytics.linkName, void 0, additionalUisPrimeMicroMessages);
        }
    };
    if (button) {
        return /* @__PURE__ */ React3.createElement(Button, {
            data: button,
            href: resource.value,
            size: buttonSize,
            isFullWidth: buttonIsFullWidth,
            className: className,
            onClickHandler: buttonClickHandler,
            onClickCapture: onClickCapture,
            inverse: inverseButton
        });
    }
    return /* @__PURE__ */ React3.createElement("a", {
        href: resource.value,
        onClickCapture: onClickCapture,
        className: className
    }, /* @__PURE__ */ React3.createElement("span", {
        className: visuallyHidden ? "is-visually-hidden" : ""
    }, accessibility));
};
IncentivesActionLink.displayName = "IncentivesActionLink";
IncentivesActionLink.fragment = __fragment;
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-collection-carousel-image.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-image-attribution.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-image-attribution-dialog.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSDialog, EGDSDialogContent, EGDSDialogFooter } from "@egds/react-core/dialog";
import { EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSText } from "@egds/react-core/text";
import { useDialog } from "@shared-ui/dialog-context";
var __fragment2 = gql4(_templateObject3());
var IncentivesImageAttributionDialog = function(param) {
    var data = param.data, dialogKey = param.dialogKey;
    var text = data.text, closeText = data.closeText;
    var _useDialog = _sliced_to_array(useDialog("image-attribution-info-".concat(dialogKey)), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    return /* @__PURE__ */ React4.createElement(EGDSSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React4.createElement(DialogComponent, null, /* @__PURE__ */ React4.createElement(EGDSDialog, {
        dialogShow: isDialogOpen,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React4.createElement(EGDSDialogContent, null, /* @__PURE__ */ React4.createElement(EGDSText, {
        theme: "emphasis"
    }, text), /* @__PURE__ */ React4.createElement(EGDSDialogFooter, {
        key: "footer",
        buttonOne: {
            onClick: dialogActions.closeDialog,
            text: closeText,
            type: "tertiary"
        }
    })))));
};
IncentivesImageAttributionDialog.displayName = "IncentivesImageAttributionDialog";
IncentivesImageAttributionDialog.fragment = __fragment2;
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-image-attribution.tsx
var __fragment3 = gql5(_templateObject4(), IncentivesImageAttributionDialog.fragment);
var IncentivesImageAttribution = function(param) {
    var data = param.data;
    var dialog = data.dialog, dialogTriggerAccessibility = data.dialogTriggerAccessibility;
    var dialogKey = React5.useMemo(function() {
        return Math.random().toString(36).substr(2, 5);
    }, []);
    var _useDialog2 = _sliced_to_array(useDialog2("image-attribution-info-".concat(dialogKey)), 2), dialogActions = _useDialog2[1];
    var handleLinkClick = React5.useCallback(function() {
        dialogActions.openDialog();
    }, [
        dialogActions
    ]);
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, /* @__PURE__ */ React5.createElement(EGDSLink, {
        onClick: handleLinkClick,
        theme: "inverse"
    }, /* @__PURE__ */ React5.createElement("button", {
        type: "button",
        "aria-label": dialogTriggerAccessibility
    }, /* @__PURE__ */ React5.createElement(EGDSIcon, {
        name: "info_outline",
        size: EGDSIconSize.SMALL
    }))), /* @__PURE__ */ React5.createElement(IncentivesImageAttributionDialog, {
        data: dialog,
        dialogKey: dialogKey
    }));
};
IncentivesImageAttribution.displayName = "IncentivesImageAttribution";
IncentivesImageAttribution.fragment = __fragment3;
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-collection-carousel-image.tsx
var __fragment4 = gql6(_templateObject5(), IncentivesImageAttribution.fragment);
var IncentivesCollectionCarouselImage = function(param) {
    var data = param.data;
    var image = data.image, attribution = data.attribution;
    return /* @__PURE__ */ React6.createElement(EGDSLayoutPosition, {
        type: "relative"
    }, /* @__PURE__ */ React6.createElement(EGDSFigure2, {
        imageFit: "cover",
        ratio: EGDSFigureAspectRatioType2.R16_9,
        roundcorner: [
            "startstart",
            "startend"
        ]
    }, /* @__PURE__ */ React6.createElement(EGDSImage, {
        placeholderImage: true,
        alt: image.description,
        src: image.url
    })), attribution && /* @__PURE__ */ React6.createElement(EGDSLayoutPosition, {
        type: "absolute",
        position: {
            bottom: "three",
            right: "three"
        }
    }, /* @__PURE__ */ React6.createElement(IncentivesImageAttribution, {
        data: attribution
    })));
};
IncentivesCollectionCarouselImage.displayName = "IncentivesCollectionCarouselImage";
IncentivesCollectionCarouselImage.fragment = __fragment4;
// src/components/incentives-collection-carousel/__private/__fragments/collection-carousel-item/incentives-content-item.tsx
var __fragment5 = gql7(_templateObject6(), IncentivesActionLink.fragment, IncentivesCollectionCarouselImage.fragment);
var IncentivesContentItem = function(props) {
    var data = props.data, collectionEventingDetails = props.collectionEventingDetails;
    var incentivesImage = data.incentivesImage, title = data.title, subtitle = data.subtitle, actionLink = data.actionLink;
    return /* @__PURE__ */ React7.createElement(EGDSCard, {
        border: true
    }, /* @__PURE__ */ React7.createElement(EGDSCardLink, null, /* @__PURE__ */ React7.createElement(IncentivesActionLink, {
        visuallyHidden: true,
        data: actionLink,
        additionalUisPrimeMicroMessages: getRecommendationClickedMessage(collectionEventingDetails, "Interaction")
    })), /* @__PURE__ */ React7.createElement(IncentivesCollectionCarouselImage, {
        data: incentivesImage
    }), /* @__PURE__ */ React7.createElement(EGDSCardContentSection, null, /* @__PURE__ */ React7.createElement(EGDSHeading, {
        overflow: "truncate",
        tag: "h4",
        size: 7
    }, title), subtitle && /* @__PURE__ */ React7.createElement(EGDSText2, {
        spacing: "half",
        overflow: "truncate",
        size: 200
    }, subtitle)));
};
IncentivesContentItem.fragment = __fragment5;
IncentivesContentItem.displayName = "IncentivesContentItem";
// src/components/incentives-collection-carousel/__private/__fragments/incentives-collection-carousel-header.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText3 } from "@egds/react-core/text";
var __fragment6 = gql8(_templateObject7());
var IncentivesCollectionCarouselHeader = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, /* @__PURE__ */ React8.createElement(EGDSHeading2, {
        size: 4
    }, data.title), data.subtitle && /* @__PURE__ */ React8.createElement(EGDSText3, {
        spacing: "two"
    }, data.subtitle));
};
IncentivesCollectionCarouselHeader.fragment = __fragment6;
IncentivesCollectionCarouselHeader.displayName = "IncentivesCollectionCarouselHeader";
// src/components/incentives-collection-carousel/incentives-collection-carousel.tsx
var __Query = gql9(_templateObject8(), IncentivesCollectionCarouselHeader.fragment, IncentivesContentItem.fragment);
var carouselSpacings = {
    margin: {
        blockstart: "three"
    }
};
var IncentivesCollectionCarousel = function(props) {
    var _data_incentivesCollection;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_showPlaceholder = props.showPlaceholder, showPlaceholder = _props_showPlaceholder === void 0 ? true : _props_showPlaceholder, _props_itemsVisibleForTracking = props.itemsVisibleForTracking, itemsVisibleForTracking = _props_itemsVisibleForTracking === void 0 ? {} : _props_itemsVisibleForTracking;
    var context = useBexApi().context;
    var formatText = useLocalization2().formatText;
    var _itemsVisibleForTracking_small = itemsVisibleForTracking.small, small = _itemsVisibleForTracking_small === void 0 ? 3 : _itemsVisibleForTracking_small, _itemsVisibleForTracking_medium = itemsVisibleForTracking.medium, medium = _itemsVisibleForTracking_medium === void 0 ? 4 : _itemsVisibleForTracking_medium, _itemsVisibleForTracking_large = itemsVisibleForTracking.large, large = _itemsVisibleForTracking_large === void 0 ? 5 : _itemsVisibleForTracking_large, _itemsVisibleForTracking_extraLarge = itemsVisibleForTracking.extraLarge, extraLarge = _itemsVisibleForTracking_extraLarge === void 0 ? 6 : _itemsVisibleForTracking_extraLarge;
    var defaultImpressionReferrerId = "INC.CAROUSEL";
    var defaultImpressionLinkName = "Incentives carousel impression event";
    var trackerEvent = useClickTracker2();
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var lastIndex = React9.useRef(0);
    var propertiesToShow = React9.useMemo(function() {
        switch(viewSize){
            case defaultViewSizes.SMALL:
                return small;
            case defaultViewSizes.MEDIUM:
                return medium;
            case defaultViewSizes.LARGE:
                return large;
            default:
                return extraLarge;
        }
    }, [
        viewSize,
        small,
        medium,
        large,
        extraLarge
    ]);
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading && showPlaceholder) {
        return /* @__PURE__ */ React9.createElement(Placeholder, null);
    }
    if (error || !(data === null || data === void 0 ? void 0 : (_data_incentivesCollection = data.incentivesCollection) === null || _data_incentivesCollection === void 0 ? void 0 : _data_incentivesCollection.collectionItems) || data.incentivesCollection.collectionItems.length === 0) {
        return null;
    }
    var _data_incentivesCollection1 = data.incentivesCollection, collectionHeader = _data_incentivesCollection1.collectionHeader, collectionItems = _data_incentivesCollection1.collectionItems, egRecommendationResponseId = _data_incentivesCollection1.egRecommendationResponseId, impressionAnalytics = _data_incentivesCollection1.impressionAnalytics;
    var getCollectionItemEventingDetails = function(item, rank) {
        if (!item.recommendationId) {
            return null;
        }
        return {
            index: rank,
            recommendationId: item.recommendationId,
            title: item.title,
            imageUrl: item.incentivesImage.image.url,
            badges: null,
            price: null
        };
    };
    var getCollectionEventingDetails = function(start, count) {
        if (!egRecommendationResponseId) {
            return void 0;
        }
        var items = collectionItems.slice(start, start + count).map(function(item, index) {
            return getCollectionItemEventingDetails(item, index + start);
        });
        var _collectionHeader_title;
        return {
            egRecommendationResponseId: egRecommendationResponseId,
            title: (_collectionHeader_title = collectionHeader === null || collectionHeader === void 0 ? void 0 : collectionHeader.title) !== null && _collectionHeader_title !== void 0 ? _collectionHeader_title : null,
            componentType: "carousel",
            items: items
        };
    };
    var itemViewedCallback = function(nextIndex) {
        if (nextIndex >= propertiesToShow) {
            var microMessages = getRecommendationSeenMessage(getCollectionEventingDetails(nextIndex, 1), lastIndex.current < nextIndex ? "right" : "left", "Impression");
            if (microMessages) {
                var _collectionItems_nextIndex_actionLink_impressionAnalytics = collectionItems[nextIndex].actionLink.impressionAnalytics, referrerId = _collectionItems_nextIndex_actionLink_impressionAnalytics.referrerId, linkName = _collectionItems_nextIndex_actionLink_impressionAnalytics.linkName;
                trackerEvent(referrerId, linkName, void 0, microMessages);
            }
            lastIndex.current = nextIndex;
        }
    };
    var carouselProps = {
        carouselName: "IncentivesCollectionCarousel",
        carouselHeaderText: collectionHeader === null || collectionHeader === void 0 ? void 0 : collectionHeader.title,
        itemViewedCallback: itemViewedCallback,
        itemsVisible: {
            sm: 2,
            md: 3,
            lg: 4,
            xl: 5
        },
        pageBy: 1,
        peek: true,
        buttonText: {
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev")
        }
    };
    var _impressionAnalytics_referrerId, _impressionAnalytics_event;
    return /* @__PURE__ */ React9.createElement(React9.Fragment, null, collectionHeader && /* @__PURE__ */ React9.createElement(IncentivesCollectionCarouselHeader, {
        data: collectionHeader
    }), /* @__PURE__ */ React9.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: (_impressionAnalytics_referrerId = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : defaultImpressionReferrerId,
        linkName: (_impressionAnalytics_event = impressionAnalytics === null || impressionAnalytics === void 0 ? void 0 : impressionAnalytics.event) !== null && _impressionAnalytics_event !== void 0 ? _impressionAnalytics_event : defaultImpressionLinkName,
        additionalUisPrimeMicroMessages: getRecommendationSeenMessage(getCollectionEventingDetails(0, propertiesToShow), "", "Impression")
    }, /* @__PURE__ */ React9.createElement(EGDSSpacing2, {
        margin: carouselSpacings.margin
    }, /* @__PURE__ */ React9.createElement(EGDSCarousel2, _object_spread({}, carouselProps), collectionItems.map(function(item, index) {
        return /* @__PURE__ */ React9.createElement(IncentivesContentItem, {
            key: "collection-carousel-content-item-".concat(index),
            data: item,
            collectionEventingDetails: getCollectionEventingDetails(index, 1)
        });
    })))));
};
IncentivesCollectionCarousel.displayName = "sharedui-IncentivesCollectionCarousel";
export { IncentivesCollectionCarousel };
//# sourceMappingURL=index.js.map